import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";

export const createOrUpdateIvrTable = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "ivrTable/createOrUpdateIvrTable",
  async (ivrTable, { getState, rejectWithValue }) => {
    const connectedInstance = getState().userInstance.connectedInstance;
    const instanceId = connectedInstance?.instanceId ?? "";
    try {
      const response = await awsClientGateway({
        pathTemplate: `/connectFlowTable/${instanceId}`,
        method: "POST",
        body: { ...ivrTable },
      });
      return await response;
    } catch (error) {
      clientLog({
        component: `ivrTable`,
        message: `Something went wrong in createOrUpdateIvrTable API => ${error}`,
      });
      logMessage(
        `ivrTable`,
        `Something went wrong in createOrUpdateIvrTable API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in createOrUpdateIvrTable api endpoint");
    }
  },
);

export const setStatusUpdate = createAction("ivrTable/setStatusUpdate");
